import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITemplateState } from '../../interfaces/state.interfaces';

const initialState: ITemplateState = {
    defaultTags: [],
    customTags: [],
};

const templateSlice = createSlice({
    name: 'template',
    initialState,
    reducers: {
        SetTemplateTags(
            state,
            action: PayloadAction<{ defaultTags: string[]; customTags: string[] }>,
        ) {
            state.defaultTags = action.payload.defaultTags;
            state.customTags = action.payload.customTags;
        },
        AddTemplateTags(state, action: PayloadAction<string[]>) {
            state.customTags = [...state.customTags, ...action.payload];
        },
        SetTemplateInitialState(state) {
            state.defaultTags = [];
            state.customTags = [];
        },
    },
});

export const { SetTemplateTags, AddTemplateTags, SetTemplateInitialState } = templateSlice.actions;

export const templateReducer = templateSlice.reducer;
